<template>
  <div class="marketingProjectManagement">
    <div class="realTaskAll">
       <realTaskmenu v-on:cut="cut" :reception="returnParameters" :cutValue="cut_result"></realTaskmenu>
      <div class="content">
        <div v-if="cut_result == 1" style="height: 100%">
          <classCompany :classCompany="classCompany" @name=myfuntion()></classCompany>
        </div>
        <div v-else-if="cut_result == 2" style="height:100%">
          <marketProjectReview
            :marketProjectReview="marketProjectReview"
             @name=myfuntion()
          ></marketProjectReview>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import newRealyObjectHeader from "./components/newRealyObjectHeader";
import classCompany from "./components/classCompany";
import marketProjectReview from "./components/marketProjectReview";
import realTaskmenu from "./components/realTaskMenu";

export default {
  data() {
    return {
      cut_result: 1,
      marketProjectReview: [],
      classCompany: [],
      params: {},
      returnParameters:-1
    };
  },
  created() {
    if (this.$route.query.value) {
      this.cut_result = this.$route.query.value
    }
  },
  methods: {
    cut(val) {
      this.cut_result = val;
    },
    myfuntion(val){
this.returnParameters = val
    },
  },

  components: {
    classCompany,
    marketProjectReview,
    newRealyObjectHeader,
    realTaskmenu,
  },
};
</script>

<style lang="scss">
.marketingProjectManagement {
  width: 100%;
  height: 100%;
  background: #f5f5f7;
  .realTaskAll {
    background: #f5f5f7;
    padding: 20px;
    display: flex;
    justify-content: center;
    height: calc(100% - 90px);
  }
  .content {
    background: #f9f9fa;
    height: 100%;
    width: 1062px;
    margin-left: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/auditNewRealTask/marketingProjectManagement.vue